import React, { useEffect, useRef, useState } from "react";
import Button from "../modules/Button";
import ModalComponent from "../modules/Modal";
import { GetBaseUrl } from "../modules/getBaseUrl";
import tick from "../../Assets/svg/green-tick.svg";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

function BtnSet(props) {
  const navigate = useNavigate()

  const myRef = useRef(null);
  const queries = useSelector((state) => state.queries);
  const [Link, setLink] = useState("");

  const [ModalData, setModalData] = useState({
    show: false,
    type: "cancel",
    title: "Cancel Query?",
    desc: "",
  });
  // const [modal, showModal] = useState(false);
  const CancelData = () => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    if (cleanedUrl.split("/")[3] === "update-queries") {
      viewField();
    } else if (cleanedUrl.split("/")[3] === "raise-queries")  {
      setModalData({
        ...ModalData,
        show: false,
      });
      viewField()
    } else  {
      setModalData({
        show: true,
        title: "Cancel Query?",
        type: "cancel",
        desc: `Are you sure you would like to cancel ${
          Link.split("/")[3] === "update-queries" ? "updating" : "raising"
        } your query`,
      });
    }
  };
  const viewField = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/help/view-queries");
    navigate("/application/help/view-queries");

  };
  const setDesc = (data) => {
    return (
      <div>
        <div>
          Your Request no is <span className="id-color">#{data}</span>
        </div>
        <div>we will get back to you at the earliest</div>
      </div>
    );
  };
  const confirmModal = async () => {
    let data = await props.onClick();
    if(data?.statusCode == 200){

      setModalData({
        show: true,
        title: (
          <div className="set-title">
            <div className="happy-icon">
              <img src={tick} alt="tick" />
            </div>
            Your query has been submitted.
          </div>
        ),
        type: "confirm",
        desc: setDesc(data?.data?.caseNumber),
      });
    }
    // else{
    //   // alert("Sorry! Something went wrong.")
    // }
    // if (data?.statusCode === 200) {

    // }
  };
  const nextPage = () => {
    if (ModalData.type === "confirm") {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(url + "/application/submission");
      navigate("/application/submission");

      setModalData({ ...ModalData, show: false });
      // } else if (type === "happy") {
      //   let url = GetBaseUrl(window.location.href);
      //   window.location.replace(url + "/signup");
      // } else {
      //   let url = GetBaseUrl(window.location.href);
      //   window.location.replace(url);
    } else if (ModalData.type === "cancel") {
      if (Link.split("/")[3] === "update-queries") {
        let url = GetBaseUrl(window.location.href);

        // window.location.replace(url + "/application/help/view-queries");
        navigate(url + "/application/help/view-queries");

      }
      setModalData({
        ...ModalData,
        show: false,
      });
    } else {
      setModalData({
        ...ModalData,
        show: false,
      });
    }
  };
  useEffect(() => {
    const cleanedUrl = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
    //   // console.log("window", cleanedUrl.split("/")[0]);
    setLink(cleanedUrl);
  }, []);
  return (
    <div className="btn-set">
      <Button
        onClickHandler={() => CancelData()}
        type={"contained override"}
        value={"Cancel"}
      />
      {/* <div className="ack-text">Saved 5 seconds ago</div> */}
      <Button
        disabled={props.btnDisable}
        type={"contained"}
        value={props.btnText ?? "Next"}
        onClickHandler={() => confirmModal()}
      />
      {/* </div> */}
      {ModalData.show && (
        <ModalComponent
          className={ModalData.type === "confirm" ? "happy" : ""}
          show={ModalData.show}
          handleClose={() => CancelData()}
          title={ModalData.title}
          content={ModalData.desc}
        >
          {ModalData.type === "cancel" ? (
            <div className="modal-btn-set">
              <Button
                onClickHandler={() =>
                  setModalData({ ...ModalData, show: false })
                }
                type={"contained override"}
                value={
                  ModalData.type === "confirm" ? "Review Again" : "No, continue"
                }
              />
              <Button
                onClickHandler={() => nextPage()}
                type={"contained "}
                value={ModalData.type === "confirm" ? "Submit" : "Yes, cancel"}
              />
            </div>
          ) : (
            <div onClick={viewField} className="left-btn upload-top-text">
              View Queries
              {/* <NavigateNextIcon fontSize="small" /> */}
            </div>
          )}
        </ModalComponent>
      )}
    </div>
  );
}

export default BtnSet;
